(() => {
  function start() {
    document.querySelectorAll('[data-densea-page]').forEach(root => {
      if (root.dataset.stickyPolished) return;
      root.dataset.stickyPolished = 'true';
      const sticky = root.querySelector('[data-sticky-add]');
      const native = root.querySelector('[data-add-button]');
      const form = native?.form;
      const image = root.querySelector('[data-sticky-image]');
      const label = sticky?.querySelector('[data-sticky-label]');
      if (!sticky || !native || !form) return;
      const sync = () => {
        const busy = native.classList.contains('loading');
        const selected = root.querySelector('[data-densea-variant]:checked');
        if (image && selected?.dataset.packPhotoThumbSrc) image.src = selected.dataset.packPhotoThumbSrc;
        sticky.disabled = busy || native.disabled;
        sticky.setAttribute('aria-busy', String(busy));
        if (label) label.textContent = busy ? sticky.dataset.addingLabel : sticky.dataset.addLabel;
      };
      sticky.addEventListener('click', () => {
        if (sticky.disabled || native.getAttribute('aria-disabled') === 'true') return;
        form.requestSubmit(native);
      });
      root.querySelectorAll('[data-densea-variant]').forEach(input => input.addEventListener('change', () => {
        if (image && input.dataset.packPhotoThumbSrc) image.src = input.dataset.packPhotoThumbSrc;
        sync();
      }));
      new MutationObserver(sync).observe(native, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
